<template>
	<div class="skyDatePicker">
		<el-date-picker
			:style="{ width: width }"
			v-model="timeValue"
			:type="pickerType"
			@change="change"
			v-bind="$attrs"
			:value-format="valueFormat"
			:unlink-panels="unlinkPanels"
			:placeholder="placeholder"
			:start-placeholder="startPlaceholder"
			:end-placeholder="endPlaceholder"
			:picker-options="pickerOptions"
			:format="valueFormat"
			:clearable="clearable"
		>
		</el-date-picker>
	</div>
</template>
<script>
export default {
	name: 'skyDatePicker',
	props: {
		value: {
			type: [String, Number, Array, Object],
		},
		placeholder: {
			type: String,
			default: '',
		},
		startPlaceholder: {
			type: String,
			default: '开始日期',
		},
		endPlaceholder: {
			type: String,
			default: '结束日期',
		},
		pickerOptions: {
			type: Object,
		},
		valueFormat: {
			type: String,
			default: 'yyyy-MM-dd',
		},
		pickerType: {
			type: String,
			default: 'date',
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		width: {
			type: String,
			default: '100%',
		},
		unlinkPanels: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			timeValue: null,
		};
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
	},
	watch: {
		value: {
			handler: function (val) {
				if (val) {
					this.timeValue = val;
				} else {
					this.timeValue = null;
				}
			},
			immediate: true,
		},
	},
};
</script>
